import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Get in touch`}</h2>
    <p>{`Please feel free to contact me at `}<a parentName="p" {...{
        "href": "mailto:pratik.p.patil1999@gmail.com"
      }}>{`pratik.p.patil1999@gmail.com`}</a>{` & `}<a parentName="p" {...{
        "href": "https://www.linkedin.com/in/pratik-p-patil-618887194"
      }}>{`LinkedIn`}</a><br parentName="p"></br>{`
`}{`Say hi on my social media `}<a parentName="p" {...{
        "href": "https://www.instagram.com/_percy_riptide_"
      }}>{`Instagram`}</a>{` & `}<a parentName="p" {...{
        "href": "https://t.me/DestinedToFail"
      }}>{`Telegram`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      